export function getAppointmentPatientName(
  appointmentOfPro: AppointmentMetaData,
  fullLastName?: boolean,
) {
  if (!appointmentOfPro.patient?.first_name) {
    return "";
  }
  return [
    appointmentOfPro.patient?.first_name[0].toUpperCase() +
      appointmentOfPro.patient?.first_name.slice(1).toLowerCase(),
    appointmentOfPro.patient?.last_name
      ? appointmentOfPro.patient?.last_name[0].toUpperCase() +
        (!fullLastName ? "." : appointmentOfPro.patient?.last_name.slice(1))
      : "",
  ]
    .filter((e) => e)
    .join(" ");
}
